import React from 'react';

import { makeStyles } from 'tss-react/mui';

import LocationMap from '@/blocks/LocationMap';
import LocationTableBlock from '@/blocks/LocationTable';
import SearchBlock from '@/blocks/Search';

import styles from '@/containers/LocationsContainer/LocationsContainer.style';

const useStyles = makeStyles()(styles);

export default function LocationsContainer({ store }) {
  const { classes } = useStyles();

  return (
    <>
      <SearchBlock store={store} />
      <div className={classes.mainWrapper}>
        <LocationMap />
        <LocationTableBlock />
      </div>
    </>
  );
}
